import { Outlet, ScrollRestoration } from 'react-router';
import { useDocumentTitle, usePageTitle } from './pageTitle';

/** The root route: keeps the browser tab's title in step with the page and restores scroll positions. */
export function RootLayout() {
  useDocumentTitle(usePageTitle());

  return (
    <>
      <ScrollRestoration />
      <Outlet />
    </>
  );
}
